var config = {
    apiKey: "AIzaSyCCoPL_nieAlPsEOHyMk98eKM2JSOSZnKc",
    authDomain: "fir-howzu.firebaseapp.com",
    databaseURL: "https://fir-howzu.firebaseio.com",
    projectId: "firebase-howzu",
    storageBucket: "firebase-howzu.appspot.com",
    messagingSenderId: "471908810178",
    appId: "1:471908810178:web:19bda1f76ce466f93baa5b"
}

export default config;